 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVERPAGE from '@/components/coverpage'
 import A780802195005_LOGO from '@/components/9780802195005_logo'
 import LOVE_1 from '@/components/love_1'
 import GROVEATLANTICLITHUB from '@/components/grove-atlantic-lithub'
 import A780802195005_HALF_TITLE from '@/components/9780802195005_half_title'
 import A780802195005_PLAYS_BY_JOHN_GUARE from '@/components/9780802195005_plays_by_john_guare'
 import A780802195005_TITLE from '@/components/9780802195005_title'
 import A780802195005_COPYRIGHT from '@/components/9780802195005_copyright'
 import A780802195005_DEDICATION from '@/components/9780802195005_dedication'
 import A780802195005_FM from '@/components/9780802195005_fm'
 import A780802195005_CH_1 from '@/components/9780802195005_ch_1'
 import A780802195005_CH_2 from '@/components/9780802195005_ch_2'
 import LOVE_2 from '@/components/love_2'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/coverpage",
 			"name" : "coverpage",
 			"component" : COVERPAGE
 		},
 		{
 			"path" : "/9780802195005_logo",
 			"name" : "9780802195005_logo",
 			"component" : A780802195005_LOGO
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/grove-atlantic-lithub",
 			"name" : "grove-atlantic-lithub",
 			"component" : GROVEATLANTICLITHUB
 		},
 		{
 			"path" : "/9780802195005_half_title",
 			"name" : "9780802195005_half_title",
 			"component" : A780802195005_HALF_TITLE
 		},
 		{
 			"path" : "/9780802195005_plays_by_john_guare",
 			"name" : "9780802195005_plays_by_john_guare",
 			"component" : A780802195005_PLAYS_BY_JOHN_GUARE
 		},
 		{
 			"path" : "/9780802195005_title",
 			"name" : "9780802195005_title",
 			"component" : A780802195005_TITLE
 		},
 		{
 			"path" : "/9780802195005_copyright",
 			"name" : "9780802195005_copyright",
 			"component" : A780802195005_COPYRIGHT
 		},
 		{
 			"path" : "/9780802195005_dedication",
 			"name" : "9780802195005_dedication",
 			"component" : A780802195005_DEDICATION
 		},
 		{
 			"path" : "/9780802195005_fm",
 			"name" : "9780802195005_fm",
 			"component" : A780802195005_FM
 		},
 		{
 			"path" : "/9780802195005_ch_1",
 			"name" : "9780802195005_ch_1",
 			"component" : A780802195005_CH_1
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js